class MegaMenu extends HTMLElement {
  connectedCallback() {
    this.cacheDom();
    this.bindEvents();
    this.clearPanels();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  cacheDom() {
    this.items = Array.from(this.querySelectorAll('[data-mega-menu-item]'));
    this.panels = new Map(
      Array.from(this.querySelectorAll('[data-mega-menu-panel]')).map((panel) => [
        panel.dataset.megaMenuPanel,
        panel,
      ])
    );
  }

  bindEvents() {
    this.onItemEnter = this.onItemEnter.bind(this);
    this.onItemLeave = this.onItemLeave.bind(this);
    this.onMenuLeave = this.onMenuLeave.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);

    this.items.forEach((item) => {
      item.addEventListener('mouseenter', this.onItemEnter);
      item.addEventListener('mouseleave', this.onItemLeave);
      item.addEventListener('focusin', this.onItemEnter);
    });

    this.addEventListener('mouseleave', this.onMenuLeave);
    this.addEventListener('focusout', this.onFocusOut);
  }

  unbindEvents() {
    this.items.forEach((item) => {
      item.removeEventListener('mouseenter', this.onItemEnter);
      item.removeEventListener('mouseleave', this.onItemLeave);
      item.removeEventListener('focusin', this.onItemEnter);
    });

    this.removeEventListener('mouseleave', this.onMenuLeave);
    this.removeEventListener('focusout', this.onFocusOut);
  }

  onItemEnter(event) {
    const item = event.currentTarget;
    const target = item.dataset.megaMenuTarget;

    if (!target) {
      this.clearPanels();
      this.setActiveItem(item, false);
      return;
    }

    this.showPanel(target, item);
  }

  onItemLeave(event) {
    const relatedTarget = event.relatedTarget;

    if (relatedTarget && this.contains(relatedTarget)) {
      return;
    }

    this.clearPanels();
  }

  onMenuLeave() {
    this.clearPanels();
  }

  onFocusOut(event) {
    if (event.relatedTarget && this.contains(event.relatedTarget)) {
      return;
    }

    this.clearPanels();
  }

  showPanel(panelId, item) {
    const panel = this.panels.get(panelId);

    this.clearPanels();

    if (!panel) {
      this.setActiveItem(item, false);
      return;
    }

    panel.classList.remove('hidden');
    panel.setAttribute('aria-hidden', 'false');

    this.setActiveItem(item, true);
    this.activePanelId = panelId;
  }

  clearPanels() {
    this.panels.forEach((panel) => {
      panel.classList.add('hidden');
      panel.setAttribute('aria-hidden', 'true');
    });

    this.items.forEach((item) => {
      item.removeAttribute('data-state');

      const trigger = item.querySelector('[data-mega-menu-trigger]');
      if (trigger?.hasAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  setActiveItem(item, shouldExpand) {
    if (!item) {
      return;
    }

    item.dataset.state = 'active';

    const trigger = item.querySelector('[data-mega-menu-trigger]');
    if (trigger?.hasAttribute('aria-expanded')) {
      trigger.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');
    }
  }
}

customElements.define('mega-menu', MegaMenu);
